import {
    LABRESULT_LIST_REQUEST, LABRESULT_LIST_SUCCESS, LABRESULT_LIST_FAIL,
    LABRESULT_DETAILS_REQUEST, LABRESULT_DETAILS_SUCCESS, LABRESULT_DETAILS_FAIL, LABRESULT_DETAILS_RESET,
    LABRESULT_CREATE_REQUEST, LABRESULT_CREATE_SUCCESS, LABRESULT_CREATE_FAIL, LABRESULT_CREATE_RESET,
    LABRESULT_UPDATE_REQUEST, LABRESULT_UPDATE_SUCCESS, LABRESULT_UPDATE_FAIL, LABRESULT_UPDATE_RESET,
    LABRESULT_DELETE_REQUEST, LABRESULT_DELETE_SUCCESS, LABRESULT_DELETE_FAIL,
    LABRESULT_DTO_REQUEST, LABRESULT_DTO_SUCCESS, LABRESULT_DTO_FAIL, LABRESULT_DTO_RESET,
    LABRESULT_LIST_BY_IDS_REQUEST, LABRESULT_LIST_BY_IDS_SUCCESS, 
    LABRESULT_LIST_BY_IDS_FAIL, LABRESULT_LIST_BY_IDS_RESET,
} from '../constants/labResultConstants';

export const labResultListReducer = (state = { labResults: [] }, action) => {
    switch (action.type) {
        case LABRESULT_LIST_REQUEST:
            return { loading: true, labResults: [] };
        case LABRESULT_LIST_SUCCESS:
            return {
                loading: false,
                labResults: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case LABRESULT_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const labResultDetailsReducer = (state = { labResult: {} }, action) => {
    switch (action.type) {
        case LABRESULT_DETAILS_REQUEST:
            return { loading: true, ...state };
        case LABRESULT_DETAILS_SUCCESS:
            return { loading: false, labResult: action.payload };
        case LABRESULT_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case LABRESULT_DETAILS_RESET:
            return { labResult: {} };
        default:
            return state;
    }
};

export const labResultDtoReducer = (state = { labResultDto: {} }, action) => {
    switch (action.type) {
        case LABRESULT_DTO_REQUEST:
            return { loading: true, labResultDto: {} };
        case LABRESULT_DTO_SUCCESS:
            return { loading: false, labResultDto: action.payload };
        case LABRESULT_DTO_FAIL:
            return { loading: false, error: action.payload };
        case LABRESULT_DTO_RESET:
            return { labResultDto: {} };
        default:
            return state;
    }
};

export const labResultDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case LABRESULT_DELETE_REQUEST:
            return { loading: true };
        case LABRESULT_DELETE_SUCCESS:
            return { loading: false, success: true };
        case LABRESULT_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const labResultCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case LABRESULT_CREATE_REQUEST:
            return { loading: true };
        case LABRESULT_CREATE_SUCCESS:
            return { loading: false, success: true, labResult: action.payload };
        case LABRESULT_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case LABRESULT_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const labResultUpdateReducer = (state = { labResult: {} }, action) => {
    switch (action.type) {
        case LABRESULT_UPDATE_REQUEST:
            return { loading: true };
        case LABRESULT_UPDATE_SUCCESS:
            return { loading: false, success: true, labResult: action.payload };
        case LABRESULT_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case LABRESULT_UPDATE_RESET:
            return { labResult: {} };
        default:
            return state;
    }
};

export const labResultListByIdsReducer = (state = { labResults: [] }, action) => {
    switch (action.type) {
        case LABRESULT_LIST_BY_IDS_REQUEST:
            return { loading: true, labResults: [] };
        case LABRESULT_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                labResults: action.payload,
            };
        case LABRESULT_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        case LABRESULT_LIST_BY_IDS_RESET:
            return { labResults: [] };
        default:
            return state;
    }
}; 